import { dash } from "sharekit";
const separator = "-";
export class GodownConfig {
    constructor() {
        this.assign = null;
        this.prefix = "godown";
        this.suffix = "";
        this.components = new Map();
        this.registry = customElements;
    }
    tag(origin) {
        return dash(this.prefix + separator + origin + separator + this.suffix);
    }
    define(name, constructor, options) {
        this.registry.define(name, constructor, options);
        this.components.set(name, constructor);
    }
    get(name) {
        return this.registry.get(name);
    }
    getName(constructor) {
        const { getName } = this.registry;
        if (getName) {
            return getName(constructor);
        }
        return [...this.components.entries()].find(([, v]) => v === constructor)?.[0] || null;
    }
    whenDefined(name) {
        return this.registry.whenDefined(name);
    }
    upgrade(root) {
        this.registry.upgrade(root);
    }
}
//# sourceMappingURL=config.js.map